export default "__VITE_ASSET__BJDb9$se__"